import React, { Component } from 'react'
import { QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, QUEUE_NUMBER_PAGE_AUDIO_SETTING_LS_KEY, } from '../QueueNumberPage'
import { getDefaultAudioSetting } from '../QueueNumberFab';

export const NUMBER_AUDIO_PLAYER_PLAY_AUDIO = "app.number-audio-player.audio.play"
let pendingNumberAudio = []

export const getAudioSetting = () => {
    let value = window.localStorage.getItem(QUEUE_NUMBER_PAGE_AUDIO_SETTING_LS_KEY)
    let defaultAudioSetting = getDefaultAudioSetting()
    if (value === null) {
        return defaultAudioSetting
    }
    else {
        // Use default values, then overwrite with current value if exists
        value = {...defaultAudioSetting, ...JSON.parse(value)}
    }
    return value
}
export const saveAudioSetting = (audioSetting) => {
    audioSetting.last_saved = (new Date()).getTime()
    window.localStorage.setItem(QUEUE_NUMBER_PAGE_AUDIO_SETTING_LS_KEY, JSON.stringify(audioSetting))
    $(document).trigger(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, [])
    return audioSetting
}
// Audio files downloaded from https://evolution.voxeo.com/library/audio/prompts/numbers/index.jsp
export default class NumberAudioPlayer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            audioSetting: getAudioSetting()
        }
    }
    componentDidMount() {
        $(document).on(NUMBER_AUDIO_PLAYER_PLAY_AUDIO, this.handlePlayAudio)
        $(document).on(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.handleAudioSettingChanged)
        window.addEventListener('storage', this.handleAudioSettingChanged)
    }
    componentWillUnmount() {
        $(document).off(NUMBER_AUDIO_PLAYER_PLAY_AUDIO, this.handlePlayAudio)
        $(document).off(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.handleAudioSettingChanged)
        window.removeEventListener('storage', this.handleAudioSettingChanged)
    }
    handleAudioSettingChanged = () => {
        let audioSetting = getAudioSetting()
        this.setState({
            audioSetting,
        })
    }
    handlePlayAudio = (e, queueNumber) => {
        if (this.state.audioSetting.audio_enabled) {
            let number = "" + queueNumber
            let numbers = number.split("")

            const repeatCount = this.state.audioSetting.repeat_count
            for (let i = 0; i < repeatCount; i++) {
                // Weird, without making copy when push to array, when later array.shift() will remove multiple element
                pendingNumberAudio.push([...numbers])
            }
            this.playNextNumberAudio()
        }
    }
    playNextNumberAudio = () => {
        if (!this.isPlayingNumberSequence && pendingNumberAudio.length > 0) {
            this.isPlayingNumberSequence = true
            let nextNumberSequence = pendingNumberAudio[0]

            // Add some delay before proceed to next sequence
            let numberSequenceTimeout = 200   // Default 200 milisecond, min = 0, max = 1800
            let speed = this.state.audioSetting.audio_wait
            numberSequenceTimeout = 100 * speed

            this.playNumberSequence(nextNumberSequence)
                .then(() => {
                    setTimeout(() => {
                        this.isPlayingNumberSequence = false
                        pendingNumberAudio.shift()
                        this.playNextNumberAudio()
                    }, numberSequenceTimeout);
                })
        }
    }

    playNumberSequence = (numberSequence) => {
        return new Promise(async (resolve, reject) => {
            await this.playNumberAudio(numberSequence)
            resolve()
        })
    }

    /**
     *
     * @param {*} numbers
     * @returns {Boolean} - true if success play audio or in middle of other audio
     */
    playNumberAudio = async (numbers, onComplete) => {
        let speed = this.state.audioSetting.audio_speed
        let waitTime = 100 * (10 - speed)

        // let minPlaybackRate = 0.5
        // let maxPlaybackRate = 1.5

        // let playbackRateGap = maxPlaybackRate - minPlaybackRate
        // let playbackRateInterval = 10
        // let playbackRate = maxPlaybackRate - playbackRateGap * ((playbackRateInterval - speed) / playbackRateInterval)
        // console.log("waitTime", waitTime)
        // console.log("playbackRate", playbackRate)
        // console.log("playbackRateGap", playbackRateGap)
        // console.log("minPlaybackRate", minPlaybackRate)
        // console.log("maxPlaybackRate", maxPlaybackRate)
        const playSingleAudioFile = (audioFile) => {
            return new Promise((resolve, reject) => {
                let audio = new Audio(audioFile)

                // audio.playbackRate = playbackRate
                audio.addEventListener('canplay', function() {
                    audio.addEventListener('ended', () => {
                        setTimeout(() => {
                            resolve()
                        }, waitTime) // A short pause before next number
                    })

                    // this function will start the music
                    audio.play()
                })
            })
        }

        return new Promise(async (resolve, reject) => {
            while (numbers.length > 0) {
                const nextNumber = numbers.shift()
                let audioFile = `/audio/numbers/${nextNumber}.wav`
                await playSingleAudioFile(audioFile)
            }
            resolve()
        })
    }
    render() {
        return (
            <div></div>
        )
    }
}
